import React from "react";

import * as Constants from "../../../../../consts/Constants.js";
import { Grid } from "@material-ui/core";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import esLocale from "date-fns/locale/es";
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Typography } from "@material-ui/core";

import Style from "../../../../../styles/js/StyleCallList.js";

import ConfigurationSelector from './configuration-selector';
import { Call } from '../../../../../plas/services/calls/models';
import service from '../../../../../plas/services/calls/service';
import alerter from "../../../../alerts/alerter"

export default function CallCreationForm( { open, cancel, created } ) {

	const theme = createTheme({
	  palette: {
	    primary: {
	      main: '#FFFFFF',
	      darker: '#FFFFFF',
	    }
	  },
	});
	const style = Style();

  	const [creating, setCreating] = React.useState(false);
  	const [call, setCall] = React.useState(new Call());
  	const [startDate, setStartDate] = React.useState(null);
  	const [endDate, setEndDate] = React.useState(null);

	React.useEffect(() => {
		if (open) {
			setCall(new Call());
			setCreating(false);
			setStartDate(null);
			setEndDate(null);
		}
	}, [open]);

  	const create = () => {
  		setCreating(true);
  		service.api.calls.create(call, (response) => {
  			if (response.result != null) {
  				created(response.result);
  			} else {
  				alerter.showError(response.error);
  			}
  			setCreating(false);
  		});
  	}

	return(
		<div>
		 	<Dialog open={open} fullWidth maxWidth="md">
		        <DialogTitle style={{background: Constants.COLOR_PRIMARY, color: 'white' }}>
		          <Typography className={style.titleInitial}>
		            Nueva convocatoria
		          </Typography>
		        </DialogTitle>
		        <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
		        	<div className={style.box} >
						<LocalizationProvider 
			        		adapterLocale={esLocale}
							dateAdapter={AdapterDateFns}>
							<Grid container alignItems="center" spacing={2}>
								<Grid item xs={12}>
							      	<TextField
							      		disabled={creating}
						                variant="outlined" 
						                id="name"
						                label="Nombre"
						                name="name"
						                onChange={ (event) => {
						                	call.name = event.target.value;
						                	setCall(new Call(call));
						                }}
						                fullWidth
						                placeholder="Nombre de la convocatoria"/>
					            </Grid>
					            <Grid item xs={6}>
									<DateTimePicker
										disabled={creating}
								        label="Fecha de apertura"
								        value={startDate}
								        onChange={(newValue) => {
								        	call.startDate = newValue.getTime();
						                	setCall(new Call(call));
						                	setStartDate(newValue);
								        }}
								        renderInput={(params) => <TextField fullWidth variant="outlined" {...params} />}>
								    </DateTimePicker>
					            </Grid>
					            <Grid item xs={6}>
									<DateTimePicker
										disabled={creating}
								        label="Fecha de cierre"
								        value={endDate}
								        onChange={(newValue) => {
											call.endDate = newValue.getTime();
						                	setCall(new Call(call));
						                	setEndDate(newValue);
								        }}
								        renderInput={(params) => <TextField fullWidth variant="outlined" {...params} />}>
								    </DateTimePicker>
					            </Grid>
								<Grid item xs={12}>
					            	<TextField
					            		disabled={creating}
						                variant="outlined" 
						                id="description"
						                label="Descripción"
						                name="description"
						                multiline
						                fullWidth
						                placeholder="Información de la convocatoria"
						                onChange={(event) => {
						                	call.description = event.target.value
						                	setCall(new Call(call));
						                }}
						            />
								</Grid>
								<Grid item xs={12} lg={12}>
					            	<ConfigurationSelector 
					            		disabled={creating}
					            		preSelect={call.configuration}
					            		select={ (configuration) => {				            		
						            		call.configurationId = configuration.id;
						            		call.configuration = configuration;
						            		setCall(new Call(call));
						            	}}/>
								</Grid>
							</Grid>
						</LocalizationProvider>
					</div>
		        </DialogContent>
		        <DialogActions style={{background: Constants.COLOR_GRAY_ULTRA_LIGHT, color: 'white' }}>
		          <ThemeProvider theme={theme}>
		            <Button 
		            	disabled={creating} 
		            	startIcon={<CancelIcon/>} 
		            	variant="contained" 
		            	onClick={() => cancel()}>
		            	Cancelar
		            </Button>
		            <LoadingButton
				        loading={creating}
				        disabled={!call.readyToCreate()}
				        loadingPosition="start"
				        startIcon={<SaveIcon />}
				        variant="contained"
				        onClick={() => create()}>
				        Crear
				      </LoadingButton>
		          </ThemeProvider>
		        </DialogActions>
	      	</Dialog>
        </div>
	)

}